import {Injectable} from "@angular/core";
import {HttpService} from "../shared/services/http.service";
import {Api} from "../shared/enum/Api";
import {Observable} from "rxjs";

@Injectable()
export class ECommerceService {
  constructor(private httpService: HttpService) {}

  public routerConfigByProductClassification(productClassification: string): Observable<any> {
    if (sessionStorage.getItem('productClassification') !== productClassification) {
      sessionStorage.clear();
    }

    productClassification = productClassification.replace("-campanha","");

    return this.httpService.post(
      'eCommercePME/eCommerceAPI/routeConfigByProductClassification',
      Api.One_Portal,
      {productClassification: productClassification}
      )
  }

  public getSpecificURL(urlCase: string, additionalParams?: any): Observable<any> {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/getSpecificURL',
      Api.One_Portal,
      {
        urlCase: urlCase,
        additionalParams: additionalParams
      }
    )
  }

  public getTimeForTimeout() {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/timeForTimeout',
      Api.One_Portal,
      null
    )
  }
}
